import styled from "@emotion/styled";
import { themeColors } from "../helpers";

export const BudgetSection = styled.section`
    background-color: ${props => themeColors.secondary};
    text-align: center;
    width: 75%;
    margin: 5% auto;
    padding: 2.5%;
    border-radius: 10px;
`;
export const BudgetDiv = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    `;

export const CardDiv = styled.div`
    padding: 15px;
    background-color: white;
    border-radius: 10px;
    text-align: center;
    width: 25%;
    min-width: fit-content;
    margin: 5px;
`;
export const Name = styled.p`
    font-weight: 500;
    font-size: 1.5rem;
    margin: 0;
`;
export const Amount = styled.p`
    font-size: 1.1rem;
    margin: 0;
`;
export const Label = styled.label`
    font-size: 0.8rem;
    margin-top: 10px;
`;
export const Input = styled.input`
    border: 1px solid black;
    border-radius: 10px;
    padding: 10px;
    text-align: center;
`;